import { render, staticRenderFns } from "./areaOfStudyMapImport.vue?vue&type=template&id=57d0e996"
import script from "./areaOfStudyMapImport.vue?vue&type=script&lang=js"
export * from "./areaOfStudyMapImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports